import { render } from "./AccountMenu.vue?vue&type=template&id=e5afa6aa"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Partials/Menu/AccountMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5afa6aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5afa6aa', __exports__)) {
    console.log('reload')
    api.reload('e5afa6aa', __exports__)
  }
  
  module.hot.accept("./AccountMenu.vue?vue&type=template&id=e5afa6aa", () => {
    console.log('re-render')
    api.rerender('e5afa6aa', render)
  })

}


export default __exports__